import { Pipe, PipeTransform } from '@angular/core';
import { IRowType } from '../models/table';

const TOP_COLOR: string = '#DADADA',
	BOTTOM_COLOR: string = '#FFFFFF',
	LEVELS_COUNT: number = 7;

type ColorRGB = {
	r: number;
	g: number;
	b: number;
}

@Pipe({
    name: 'colorTableRow',
    standalone: true
})
export class ColorTableRowPipe implements PipeTransform {

	constructor() {}

	transform(row: IRowType, levelsCount: number = LEVELS_COUNT): string {
		if (!row.children) return BOTTOM_COLOR;
		if (row.children && !row.level) return TOP_COLOR;

		const colors: Array<string> = this.generateColors(levelsCount);

		return colors[row.level || 0];
	}

	generateColors(levelsCount: number): Array<string> {
		const colors: string[] = [];

		// color conversion in RGB format
		const topRGB: ColorRGB = this.hexToRGB(TOP_COLOR);
		const bottomRGB: ColorRGB = this.hexToRGB(BOTTOM_COLOR);

		// calculating the difference between colors
		const diffRGB: ColorRGB = {
			r: (topRGB.r - bottomRGB.r) / (levelsCount - 1),
			g: (topRGB.g - bottomRGB.g) / (levelsCount - 1),
			b: (topRGB.b - bottomRGB.b) / (levelsCount - 1),
		};

		// color generation for each level
		for (let i: number = 0; i < levelsCount; i++) {
			const levelRGB: ColorRGB = {
				r: Math.round(topRGB.r - i * diffRGB.r),
				g: Math.round(topRGB.g - i * diffRGB.g),
				b: Math.round(topRGB.b - i * diffRGB.b),
			};

			// convert RGB color back to hexadecimal format
			const levelColor: string = this.RGBToHex(levelRGB.r, levelRGB.g, levelRGB.b);
			colors.push(levelColor);
		}

		return colors;
	}

	hexToRGB(hex: string): ColorRGB {
		const bigint: number = parseInt(hex.replace('#', ''), 16);
		return {
			r: (bigint >> 16) & 255,
			g: (bigint >> 8) & 255,
			b: bigint & 255,
		};
	}

	RGBToHex(r: number, g: number, b: number): string {
		const componentToHex = (color: number) => {
			const hex: string = color.toString(16);
			return hex.length === 1 ? '0' + hex : hex;
		};
		return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
	}
}